import {makeStyles} from '@mui/styles';

export const useStyles = makeStyles({
  navbarComponentHeading: {
    width: 194,
    height: 80,
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#1c1939',
  },
  loader: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1,
  },
});
